function setCookie(name: string, value: string, days: number): void {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

function getCookie(name: string): string | null {
  const cookieArray = document.cookie.split('; ');
  for (const cookie of cookieArray) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) {
      if (!cookieValue)
        throw new Error(`value for cookieName: ${cookieName} is empty`);

      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}

const CONSENT_COOKIE_NAME = 'userConsent';

export const useCookieConsent = () => {
  const $q = useQuasar();
  const { t } = useI18n();

  // SSR: браузер-API (document.cookie, Notify) недоступны на сервере.
  const showCookieNotification = (): void => {
    if (typeof document === 'undefined') return;

    if (getCookie(CONSENT_COOKIE_NAME)) return;

    $q.notify({
      icon: 'cookie',
      message: t('COOKIE_CONSENT.MESSAGE'),
      caption: t('COOKIE_CONSENT.CAPTION'),
      html: true,
      multiLine: true,
      actions: [
        {
          label: t('COOKIE_CONSENT.ACCEPT'),
          color: 'white',
          class: 'cookie-btn',
          handler: () => {
            setCookie(CONSENT_COOKIE_NAME, 'accepted', 365);
          },
        },
      ],
      timeout: 0,
      position: 'bottom',
      color: 'dark',
      textColor: 'white',
      classes: 'cookie-consent-banner',
    });
  };

  return {
    showCookieNotification,
  };
};
